(function () {
  "use strict";
  if (location.pathname.indexOf("/products/") === -1) return;
  var X = "/cdn/shop/files/itf-stamp.json",
    P = "/cdn/shop/files/itf-soh.json",
    Y = "/cdn/shop/files/itf-packs.json",
    G = [
      "/cdn/shop/files/itf-soh-acco-exc.json",
      "/cdn/shop/files/itf-soh-phe-exc.json",
      "/cdn/shop/files/itf-soh-staedtler.json",
      "/cdn/shop/files/itf-soh-avery-exc.json",
    ],
    O = ["QLD", "NSW", "VIC", "WA", "SA"],
    x = "/pages/contact",
    h = [
      {
        max: 0,
        key: "pre",
        color: "#9F0C0C",
        lit: 0,
        ang: 172,
        label: "Restocking",
      },
      {
        max: 10,
        key: "few",
        color: "#CE5F13",
        lit: 1,
        ang: 140,
        label: "Last Few",
      },
      {
        max: 50,
        key: "low",
        color: "#FAB219",
        lit: 3,
        ang: 90,
        label: "Low Stock",
      },
      {
        max: 1 / 0,
        key: "in",
        color: "#319F0C",
        lit: 5,
        ang: 8,
        label: "In Stock",
      },
    ],
    ae = {
      key: "else",
      color: "#666666",
      lit: 0,
      ang: 172,
      label: "Ships Interstate",
    },
    K = "#C6C6C6",
    D = "11am";
  function I(e) {
    if (e == null || e <= 0) return h[0];
    for (var t = 1; t < h.length; t++) if (e <= h[t].max) return h[t];
    return h[h.length - 1];
  }
  var W =
      '.mos-soh{font-family:"Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;border:1px solid #E6E6E6;border-radius:14px;background:#fff;padding:18px 20px 16px;margin:18px 0;box-shadow:0 1px 2px rgba(0,0,0,.04),0 6px 22px rgba(15,73,160,.06);color:#666;letter-spacing:-.2px;-webkit-font-smoothing:antialiased}.mos-soh *{box-sizing:border-box}.mos-soh__head{display:flex;align-items:baseline;justify-content:space-between;gap:12px;flex-wrap:wrap;margin:0 0 14px}.mos-soh__title{font-size:13px;font-weight:700;letter-spacing:.05em;text-transform:uppercase;color:#0B3A82;margin:0}.mos-soh__when{font-size:11.5px;color:#8A8A8A;margin:0}.mos-soh__verdict{display:flex;align-items:center;gap:9px;margin:0 0 12px;padding:0 0 12px;border-bottom:1px solid #EDEDED}.mos-soh__dot{width:10px;height:10px;border-radius:50%;flex:none}.mos-soh__vt{font-size:14px;font-weight:600;color:#000;letter-spacing:-.2px}.mos-soh__grid{display:grid;gap:8px;grid-template-columns:repeat(5,minmax(0,1fr));max-width:600px}.mos-soh__grid--few{max-width:none;justify-content:start;grid-template-columns:repeat(var(--n,1),minmax(88px,116px))}.mos-soh__cell{position:relative;border:1px solid #E6E6E6;border-radius:10px;background:#F6F6F6;padding:9px 4px 10px;text-align:center;text-decoration:none;display:block;color:inherit}.mos-soh__cell[data-tip]::after{content:attr(data-tip);position:absolute;left:50%;bottom:calc(100% + 8px);transform:translateX(-50%) translateY(3px);background:#1a1a19;color:#fff;font-size:11.5px;font-weight:500;line-height:1.35;letter-spacing:-.1px;padding:6px 9px;border-radius:7px;white-space:nowrap;opacity:0;visibility:hidden;transition:opacity .13s,transform .13s;pointer-events:none;z-index:20;box-shadow:0 4px 14px rgba(0,0,0,.18)}.mos-soh__cell[data-tip]::before{content:"";position:absolute;left:50%;bottom:calc(100% + 3px);transform:translateX(-50%);border:5px solid transparent;border-top-color:#1a1a19;opacity:0;visibility:hidden;transition:opacity .13s;pointer-events:none;z-index:20}.mos-soh__cell[data-tip]:hover::after,.mos-soh__cell[data-tip]:focus::after{opacity:1;visibility:visible;transform:translateX(-50%) translateY(0)}.mos-soh__cell[data-tip]:hover::before,.mos-soh__cell[data-tip]:focus::before{opacity:1;visibility:visible}.mos-soh__cell:nth-child(1)[data-tip]::after,.mos-soh__cell:nth-child(2)[data-tip]::after{left:0;transform:translateX(0) translateY(3px)}.mos-soh__cell:nth-child(1)[data-tip]:hover::after,.mos-soh__cell:nth-child(2)[data-tip]:hover::after,.mos-soh__cell:nth-child(1)[data-tip]:focus::after,.mos-soh__cell:nth-child(2)[data-tip]:focus::after{transform:translateX(0) translateY(0)}.mos-soh__cell:nth-child(4)[data-tip]::after,.mos-soh__cell:nth-child(5)[data-tip]::after{left:auto;right:0;transform:translateX(0) translateY(3px)}.mos-soh__cell:nth-child(4)[data-tip]:hover::after,.mos-soh__cell:nth-child(5)[data-tip]:hover::after,.mos-soh__cell:nth-child(4)[data-tip]:focus::after,.mos-soh__cell:nth-child(5)[data-tip]:focus::after{transform:translateX(0) translateY(0)}@media (hover:none){.mos-soh__cell[data-tip]::after,.mos-soh__cell[data-tip]::before{display:none}}a.mos-soh__cell{transition:background .15s,border-color .15s}a.mos-soh__cell:hover,a.mos-soh__cell:focus{background:#FFF0E0;border-color:#F0C9A0;outline:none}.mos-soh__st{display:block;font-size:10.5px;font-weight:700;letter-spacing:.06em;color:#666;margin:0 0 2px}.mos-soh__g{display:block;margin:0 auto;width:52px;height:31px}.mos-soh__lb{display:block;font-size:10px;font-weight:700;line-height:1.25;margin-top:3px;letter-spacing:-.1px}.mos-soh__foot{font-size:11.5px;color:#8A8A8A;margin:12px 0 0}.mos-soh__foot a{color:#0F49A0}@media (max-width:520px){.mos-soh{padding:14px 12px 12px}.mos-soh__grid{gap:5px}.mos-soh__cell{padding:7px 2px 8px}.mos-soh__g{width:42px;height:25px}.mos-soh__lb{font-size:9px}}',
    b = document.currentScript || null,
    f = null,
    T = {},
    y = [],
    s = null,
    w = null;
  function k(e) {
    return String(e || "")
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, "");
  }
  function S(e) {
    return e ? (e.textContent || "").trim() : "";
  }
  function m(e) {
    return String(e)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/"/g, "&quot;");
  }
  function M() {
    if (!document.getElementById("mos-soh-css")) {
      var e = document.createElement("style");
      ((e.id = "mos-soh-css"),
        (e.textContent = W),
        document.head.appendChild(e));
    }
  }
  function B() {
    var e = [],
      t = document.querySelector('[id^="Sku-"]');
    if (t) {
      var o = k(S(t).replace(/^SKU:\s*/i, ""));
      o && (e.push(o), o.indexOf("DS") === 0 && e.push(o.slice(2)));
    }
    var n = S(document.querySelector(".upc-value"));
    n && e.push(k(n));
    var c = S(document.querySelector(".mpn-value"));
    return (
      c && e.push(k(c)),
      e.filter(function (d, r, p) {
        return d && p.indexOf(d) === r;
      })
    );
  }
  function Z() {
    if (!f) return null;
    for (var e = B(), t = 0; t < e.length; t++)
      if (f.s[e[t]]) return { key: e[t], stock: f.s[e[t]] };
    return null;
  }
  function L() {
    var e = document.getElementById("mos-soh-slot");
    if (e) return { el: e, where: "in" };
    if (b && b.parentNode && b.parentNode.tagName !== "HEAD")
      return { el: b, where: "after" };
    var t = document.querySelector(".recharge-subscription-widget");
    if (t && t.parentNode) return { el: t, where: "after" };
    var o = document.querySelector(".product-dropdown_information");
    if (o && o.parentNode) return { el: o, where: "before" };
    var n = document.querySelector("product-form");
    return n && n.parentNode ? { el: n, where: "after" } : null;
  }
  var q = 5,
    z = 3.2,
    C = 182,
    $ = -2;
  function v(e, t, o, n) {
    var c = (n * Math.PI) / 180;
    return [e + o * Math.cos(c), t - o * Math.sin(c)];
  }
  function Q(e, t, o, n, c, d) {
    var r = v(e, t, n, c),
      p = v(e, t, n, d),
      i = v(e, t, o, d),
      _ = v(e, t, o, c);
    return (
      "M" +
      r[0].toFixed(1) +
      " " +
      r[1].toFixed(1) +
      " A" +
      n +
      " " +
      n +
      " 0 0 1 " +
      p[0].toFixed(1) +
      " " +
      p[1].toFixed(1) +
      " L" +
      i[0].toFixed(1) +
      " " +
      i[1].toFixed(1) +
      " A" +
      o +
      " " +
      o +
      " 0 0 0 " +
      _[0].toFixed(1) +
      " " +
      _[1].toFixed(1) +
      " Z"
    );
  }
  function V(e) {
    for (
      var t = 62, o = 60, n = 30, c = 50, d = (C - $) / q, r = "", p = 0;
      p < q;
      p++
    ) {
      var i = C - p * d - z / 2,
        _ = C - (p + 1) * d + z / 2;
      r +=
        '<path d="' +
        Q(t, o, n, c, i, _) +
        '" fill="' +
        (p < e.lit ? e.color : K) +
        '"/>';
    }
    var E = v(t, o, n + 13, e.ang);
    return (
      (r +=
        '<line x1="' +
        t +
        '" y1="' +
        o +
        '" x2="' +
        E[0].toFixed(1) +
        '" y2="' +
        E[1].toFixed(1) +
        '" stroke="' +
        e.color +
        '" stroke-width="5" stroke-linecap="round"/>'),
      (r +=
        '<circle cx="' +
        t +
        '" cy="' +
        o +
        '" r="8.5" fill="' +
        e.color +
        '"/>'),
      '<svg class="mos-soh__g" viewBox="0 0 124 74" aria-hidden="true" focusable="false">' +
        r +
        "</svg>"
    );
  }
  function J() {
    var e = document.querySelector('[id^="Sku-"]');
    return e ? k(S(e).replace(/^SKU:\s*/i, "")) : "";
  }
  function ee(e) {
    var t = T[J()] || 1,
      o =
        t > 1
          ? e.stock.map(function (a) {
              return typeof a == "number" ? Math.floor(a / t) : a;
            })
          : e.stock,
      n = function (a) {
        var l = o[a];
        return l == null ? null : l;
      },
      c = f.built ? " \xB7 as at " + f.built : "",
      d = o.length > 5 && typeof o[5] == "number" ? o[5] : 0,
      r = [];
    O.forEach(function (a, l) {
      (n(l) || 0) > 0 && r.push({ st: a, i: l, n: n(l) });
    });
    var p = O.filter(function (a, l) {
        return !((n(l) || 0) > 0);
      }),
      i = r.length > 0,
      _ = function (a) {
        return a > 5e3 ? "5,000+" : a.toLocaleString("en-AU");
      },
      E = r
        .map(function (a) {
          var l = I(a.n),
            H = a.st + " \u2014 " + _(a.n) + " on hand" + c,
            re =
              '<span class="mos-soh__st">' +
              a.st +
              "</span>" +
              V(l) +
              '<span class="mos-soh__lb" style="color:' +
              l.color +
              '">' +
              l.label +
              "</span>";
          return (
            '<div class="mos-soh__cell" data-tip="' +
            m(H) +
            '" aria-label="' +
            m(a.st + ": " + l.label + ". " + H) +
            '">' +
            re +
            "</div>"
          );
        })
        .join(""),
      g = null;
    r.forEach(function (a) {
      var l = I(a.n);
      (!g || h.indexOf(l) > h.indexOf(g)) && (g = l);
    });
    var N, j;
    i
      ? ((N = g.color),
        (j =
          g.label +
          (d > 0
            ? " \u2014 more on the way"
            : r.length <= 2
              ? " \u2014 ships from " +
                r
                  .map(function (a) {
                    return a.st;
                  })
                  .join(" and ")
              : "")))
      : ((N = h[0].color),
        (j = d > 0 ? "On order \u2014 arriving soon" : "Restocking"));
    var A;
    i
      ? p.length === 0
        ? (A =
            "In stock in every state. Order before " +
            D +
            " for same-day dispatch.")
        : (A =
            "Ships to " +
            p.join(", ").replace(/, ([A-Z]+)$/, " and $1") +
            " from the nearest state that has it. Order before " +
            D +
            " for same-day dispatch.")
      : (A =
          d > 0
            ? 'None on hand right now, but a delivery is inbound. <a href="' +
              x +
              "\">Get in touch</a> and we'll confirm timing."
            : 'None on hand anywhere right now \u2014 we can still order this in. <a href="' +
              x +
              "\">Get in touch</a> and we'll confirm lead time.");
    var ne =
      '<div class="mos-soh__head"><p class="mos-soh__title">Stock on hand</p><p class="mos-soh__when">' +
      (f.built ? "Updated " + m(f.built) : "") +
      '</p></div><div class="mos-soh__verdict"><span class="mos-soh__dot" style="background:' +
      N +
      '"></span><span class="mos-soh__vt">' +
      j +
      "</span></div>" +
      (i
        ? '<div class="mos-soh__grid' +
          (r.length < 5 ? " mos-soh__grid--few" : "") +
          '" style="--n:' +
          r.length +
          '">' +
          E +
          "</div>"
        : "") +
      '<p class="mos-soh__foot">' +
      A +
      "</p>";
    if (!s) {
      var u = L();
      if (!u) return;
      ((s = document.createElement("div")),
        (s.className = "mos-soh"),
        u.where === "in"
          ? u.el.appendChild(s)
          : u.where === "after"
            ? u.el.parentNode.insertBefore(s, u.el.nextSibling)
            : u.el.parentNode.insertBefore(s, u.el));
    }
    ((s.innerHTML = ne), (s.style.display = ""));
  }
  function te() {
    for (var e = B(), t = 0; t < y.length; t++) {
      var o = y[t];
      if (!(!o || !o.s)) {
        for (var n = 0; n < e.length; n++)
          if (o.s[e[n]]) return { rec: o.s[e[n]], doc: o };
      }
    }
    return null;
  }
  function oe(e) {
    var t = e.rec,
      o = e.doc,
      n = t.kind === "mto",
      c,
      d,
      r;
    n
      ? ((c = h[2].color),
        (d =
          "Made to order" + (t.lead ? " &mdash; ships in " + m(t.lead) : "")),
        (r =
          "This line is made to order rather than held in stock, so it is always available to buy. Order it and we will have it made and on its way" +
          (t.lead ? " within " + m(t.lead) : " shortly") +
          '. <a href="' +
          x +
          '">Get in touch</a> if you need it sooner.'))
      : ((c = h[0].color),
        (d =
          "Restocking &mdash; " +
          (t.eta && /\d/.test(t.eta)
            ? "Expected back " + m(t.eta)
            : "Date to be confirmed")),
        (r =
          'Our supplier is temporarily out of this line. You can still order it and we will send it as soon as it lands, or <a href="' +
          x +
          '">get in touch</a> and we will suggest something we can ship today.'));
    var p =
      '<div class="mos-soh__head"><p class="mos-soh__title">Stock on hand</p><p class="mos-soh__when">' +
      (o.built ? "Updated " + m(o.built) : "") +
      '</p></div><div class="mos-soh__verdict"><span class="mos-soh__dot" style="background:' +
      c +
      '"></span><span class="mos-soh__vt">' +
      d +
      '</span></div><p class="mos-soh__foot">' +
      r +
      "</p>";
    if (!s) {
      var i = L();
      if (!i) return;
      ((s = document.createElement("div")),
        (s.className = "mos-soh"),
        i.where === "in"
          ? i.el.appendChild(s)
          : i.where === "after"
            ? i.el.parentNode.insertBefore(s, i.el.nextSibling)
            : i.el.parentNode.insertBefore(s, i.el));
    }
    ((s.innerHTML = p), (s.style.display = ""));
  }
  function F() {
    var e = Z(),
      t = !1;
    if (e) {
      for (var o = 0; o < 5; o++)
        if (typeof e.stock[o] == "number" && e.stock[o] > 0) {
          t = !0;
          break;
        }
    }
    if (!t) {
      var n = te();
      if (n) {
        (M(), oe(n), (w = "exc"));
        return;
      }
    }
    if (!e) {
      (s && (s.style.display = "none"), (w = null));
      return;
    }
    (e.key === w && s && s.style.display !== "none") ||
      ((w = e.key), M(), ee(e));
  }
  /* --- split stock feed (ported from Mega pdp-stock.js, 23 Sep 2026) ---
     itf-stamp.json says whether the feed is also published in `sn` pieces
     (itf-sohx-NN.json). If so, only the piece(s) holding this product's keys
     are fetched (~20 KB) instead of the whole itf-soh.json (~780 KB). Any
     doubt at any step falls back to the full file, once. */
  var SX = "/cdn/shop/files/itf-sohx-",
    MODE = "full",
    SN = 0,
    SV = "",
    VV = "",
    HAVE = {},
    INFLIGHT = {},
    FULL = null;
  function pieceOf(key) {
    for (var h = 2166136261, i = 0; i < key.length; i++) {
      h ^= key.charCodeAt(i);
      h = Math.imul(h, 16777619) >>> 0;
    }
    return ((h ^ (h >>> 16)) >>> 0) % SN;
  }
  function loadPiece(n) {
    if (INFLIGHT[n]) return INFLIGHT[n];
    return (INFLIGHT[n] = fetch(
      SX + (n < 10 ? "0" : "") + n + ".json?v=" + encodeURIComponent(VV),
      { credentials: "omit" }
    )
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      })
      .then(function (d) {
        if (!d || d.v !== SV || d.n !== SN || !d.s) throw new Error("build");
        for (var k in d.s) f.s[k] = d.s[k];
        if (d.built) f.built = d.built;
        HAVE[n] = !0;
        return !0;
      }));
  }
  function loadFull() {
    if (FULL) return FULL;
    MODE = "full";
    return (FULL = fetch(P + "?v=" + encodeURIComponent(VV), {
      credentials: "omit",
    })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      })
      .then(function (d) {
        if (d && d.s) f = d;
        return f;
      }));
  }
  /* Walk the keys in the same order Z() tries them. Load the first key's
     piece; only if that key is absent move on to the next key's piece. */
  function ensureKeys() {
    if (MODE !== "shard") return Promise.resolve();
    var keys = B();
    function step(i) {
      if (i >= keys.length) return Promise.resolve();
      var n = pieceOf(keys[i]);
      var p = HAVE[n] ? Promise.resolve(!0) : loadPiece(n);
      return p.then(function () {
        if (f.s[keys[i]]) return;
        return step(i + 1);
      });
    }
    return step(0).catch(function () {
      return loadFull();
    });
  }
  function FS() {
    ensureKeys().then(F, F);
  }
  function U() {
    var e =
      document.querySelector('[id^="SkuWrapper-"]') ||
      document.querySelector('[id^="Sku-"]');
    if (e) {
      var t = null;
      new MutationObserver(function () {
        (clearTimeout(t), (t = setTimeout(FS, 120)));
      }).observe(e.parentNode || e, {
        childList: !0,
        subtree: !0,
        characterData: !0,
      });
    }
  }
  function R() {
    fetch(X + "?v=" + Date.now(), { credentials: "omit", cache: "no-store" })
      .then(function (e) {
        return e.ok ? e.json() : null;
      })
      .catch(function () {
        return null;
      })
      .then(function (e) {
        var t = (e && e.v) || String(Math.floor(Date.now() / 6e5));
        VV = t;
        var stock;
        if (e && typeof e.sv == "string" && e.sv && e.sn > 0 && e.sn < 4096) {
          SN = e.sn | 0;
          SV = e.sv;
          MODE = "shard";
          f = { v: SV, built: "", s: {} };
          stock = ensureKeys().then(function () {
            return f;
          });
        } else {
          stock = loadFull();
        }
        return Promise.all([
          stock,
          fetch(Y + "?v=" + encodeURIComponent(t), { credentials: "omit" })
            .then(function (o) {
              return o.ok ? o.json() : {};
            })
            .catch(function () {
              return {};
            }),
          Promise.all(
            G.map(function (o) {
              return fetch(o + "?v=" + encodeURIComponent(t), {
                credentials: "omit",
              })
                .then(function (n) {
                  return n.ok ? n.json() : null;
                })
                .catch(function () {
                  return null;
                });
            }),
          ),
        ]);
      })
      .then(function (e) {
        ((T = e[1] || {}),
          (y = (e[2] || []).filter(Boolean)),
          e[0] && e[0].s ? ((f = e[0]), F(), U()) : y.length && (F(), U()));
      })
      .catch(function () {});
  }
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", R)
    : R();
})();
